import React from 'react'
import { Hero } from '../components/ContactSupport/Hero'
import { Inquiries } from '../components/ContactSupport/Inquiries'
import { MapInquiry } from '../components/ContactSupport/MapInquiry'

export const Contact = () => {
  return (
    <>
   <Hero />
   <Inquiries />
   <MapInquiry />
    </>
  )
}
